import { Component, OnInit, signal } from '@angular/core';
import { environment } from '../environments/environment';
import { RouterOutlet } from '@angular/router';
import { MaterialImports } from './material.imports';

@Component({
  selector: 'app-root',
  imports: [...MaterialImports, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('I4U');

  constructor() {
    // Constructor runs first
  }

  // OnInit runs after inputs are initialized
  ngOnInit(): void {
    console.log('Environment:', environment.name);
  }
}
